async function validatePhone(phone: string): Promise<number> {
  try {

    const timeout = new Promise<number>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 3000),
    );
    const url = `https://ruuf-backend.online/auth/send-destination-to-ruuf`;

    const response = await Promise.race([
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ destination: phone }),
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    const data = await response.json();

    if (response.status === 200) {
      console.log("Phone is valid");
      console.log(data.success);
      return 0; // Phone is valid
    } else if (response.status === 500) {
      console.error("Invalid phone");
      console.log(data.message);
      return 1; // Invalid phone
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error("Error validating phone:", error);
    return -1; // Error validating phone
  }
}

export default validatePhone;
